import { MainLayout } from 'src/pages/MainLayout';
import { DiscountsDashboard } from './DiscountCodeDashboard';
import { CreateDiscountCodeSheet } from './CreateDiscountCodeSheet';
import { useState } from 'react';

const PageTitle = () => {
  return (
    <div className="flex flex-col">
      <h1 className="text-3xl font-bold pb-3">Discount Codes</h1>
      <p className="text-slate-500 dark:text-slate-400 pb-4">
        Manage discount codes and track their usage
      </p>
    </div>
  );
};

const PageHeader = ({
  createDiscountCodeSheetOpen,
  setCreateDiscountCodeSheetOpen,
}: {
  createDiscountCodeSheetOpen: boolean;
  setCreateDiscountCodeSheetOpen: (open: boolean) => void;
}) => {
  return (
    <>
      <PageTitle />
      <CreateDiscountCodeSheet
        setIsCreateModalOpen={setCreateDiscountCodeSheetOpen}
        isOpen={createDiscountCodeSheetOpen}
      />
    </>
  );
};

export const DiscountsPage = () => {
  const [createDiscountCodeSheetOpen, setCreateDiscountCodeSheetOpen] = useState(false);
  return (
    <MainLayout>
      <div className="flex flex-col sm:flex-row sm:space-y-0 sm:justify-between sm:items-center">
        <PageHeader
          createDiscountCodeSheetOpen={createDiscountCodeSheetOpen}
          setCreateDiscountCodeSheetOpen={setCreateDiscountCodeSheetOpen}
        />
      </div>
      <DiscountsDashboard />
    </MainLayout>
  );
};
